module.exports = window["lapilliUI"]["components"];